import {createSelector, MemoizedSelector} from '@ngrx/store';
import {getClientSlicesStore} from '@app/store/client-slices/client-slices-selectors';

export const getOperationStoreState = createSelector(
  getClientSlicesStore,
  (clientStore) => clientStore.operation
);

export const getOperationStoreStatus = createSelector(
  getOperationStoreState,
  (operationData) => operationData
);

export const selectOperationStatus = (correlationId: string):
  MemoizedSelector<any, boolean> =>
  createSelector(
    getOperationStoreState,
    (operationStatus) =>
      operationStatus.correlationId === correlationId
  );


